import SpaceForButton from '@/components/_common/SpaceForButtons';
import GenerateRemmitanceButton from './GenerateRemmitanceButton';
import ReturnFileButton from './ReturnFileButton';
import ConsultFileButton from './ConsultFileButton';
import WriteOffButton from './WriteOffButton';
import WriteOffGenerateRemmitanceButton from './WriteOffGenerateRemmitanceButton';

export default function BankSlipFooter() {
  return (
    <>
      <SpaceForButton>
        <GenerateRemmitanceButton />

        <ReturnFileButton />

        <ConsultFileButton />

        <WriteOffButton />

        <WriteOffGenerateRemmitanceButton />
      </SpaceForButton>
    </>
  );
}
